
    import { defineComponent } from 'vue'
    import { AxiosResponse } from 'axios'
    import { mapState } from 'vuex'
    import Dialog from 'primevue/dialog'
    import documentExecutionHelpDialogDescriptor from './DocumentExecutionHelpDialogDescriptor.json'
    import DocumentExecutionWordDetail from './DocumentExecutionWordDetail.vue'
    import Listbox from 'primevue/listbox'

    export default defineComponent({
        name: 'document-execution-help-dialog',
        components: { Dialog, DocumentExecutionWordDetail, Listbox },
        props: { visible: { type: Boolean }, propDocument: { type: Object } },
        emits: ['close'],
        data() {
            return {
                documentExecutionHelpDialogDescriptor,
                document: null as any,
                words: [] as { WORD_ID: number; WORD: string }[],
                wordDetail: null as any,
                selectedWordName: '' as string
            }
        },
        computed: {
            ...mapState({
                isEnterprise: 'isEnterprise'
            })
        },
        watch: {
            async propDocument() {
                await this.loadDocument()
            }
        },
        async created() {
            await this.loadDocument()
        },
        methods: {
            async loadDocument() {
                this.document = this.propDocument ? { ...this.propDocument } : {}
                if (this.isEnterprise && this.document.id) await this.loadDocumentWords()
            },
            async loadDocumentWords() {
                this.$store.commit('setLoading', true)
                await this.$http
                    .get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `1.0/glossary/getDocumentInfo?DOCUMENT_ID=${this.document.id}`)
                    .then((response: AxiosResponse<any>) => (this.words = response.data.word))
                    .finally(() => this.$store.commit('setLoading', false))
            },
            async loadWordDetail(word: { WORD_ID: number; WORD: string }) {
                this.$store.commit('setLoading', true)
                await this.$http
                    .get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `1.0/glossary/getWord?WORD_ID=${word?.WORD_ID}`)
                    .then((response: AxiosResponse<any>) => {
                        this.selectedWordName = word.WORD
                        this.wordDetail = response.data
                    })
                    .finally(() => this.$store.commit('setLoading', false))
            },
            closeDialog() {
                this.$emit('close')
            }
        }
    })
